import { Injectable } from "@angular/core";
import {
  Appointment,
  IAppointment,
  IDataSourceBackendParam,
  IFilter,
  IPatientAppointement,
  ISchedule,
  ITeleconsultationInfo,
} from "@comunicare/comunicare-interfaces";
import { IAppointmentService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { Observable } from "rxjs";

/* tslint:disable:no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* tslint:disable:no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
  providedIn: "root",
})
export class AppointmentService implements IAppointmentService {
  list(): Observable<Appointment[]> {
    throw new Error("Method not implemented.");
  }
  getPatientAppointement(name: string): Observable<IPatientAppointement[]> {
    throw new Error("Method not implemented.");
  }
  listVisioAppointements(patientId: string, allAppointments?: boolean): Observable<Appointment[]> {
    throw new Error("Method not implemented.");
  }
  deleteApp(app: Appointment): Observable<unknown> {
    throw new Error("Method not implemented.");
  }
  createVisioAppointement(app: IAppointment): Observable<Appointment> {
    throw new Error("Method not implemented.");
  }
  updateVisioAppointement(app: IAppointment): Observable<IAppointment> {
    throw new Error("Method not implemented.");
  }
  getTeleconsultations(params: IDataSourceBackendParam): Observable<ITeleconsultationInfo[]> {
    throw new Error("Method not implemented.");
  }
  getTeleconsultationsCount(filters?: IFilter[], services?: string[], org?: string): Observable<{ count: number }> {
    throw new Error("Method not implemented.");
  }
  getAgendaList(services: string[], org: string): Observable<ISchedule[]> {
    throw new Error("Method not implemented.");
  }
  startVideoCall(appointment: Appointment): void {
    throw new Error("Method not implemented.");
  }
  autoAssignAppointments(appointments: Appointment[]): Observable<IAppointment[]> {
    throw new Error("Method not implemented.");
  }
}
